import { render, staticRenderFns } from "./OrderStepTransportAndPayment.vue?vue&type=template&id=6ae70a83&"
import script from "./OrderStepTransportAndPayment.vue?vue&type=script&lang=js&"
export * from "./OrderStepTransportAndPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports